var config = {
  parserURL: 'https://europe-west1-il2-horus-demo-services.cloudfunctions.net/missions-parse'
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/jsx/config/production.config.jsx